<template>
  <div class="courses-single-content">
    <template v-if="!loading">
      <template v-if="lesson && course">
        <template v-if="lesson">
          <div class="reader-widget">
            <div class="change-font-size-down" @click.prevent="lessSize()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-dash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
                />
              </svg>
            </div>
            <div class="change-font-size-up" @click.prevent="moreSize()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                />
              </svg>
            </div>

            <div
              class="activate-read-mode"
              @click.prevent="
                $store.state.courses.readMode = !$store.state.courses.readMode
              "
            >
              <svg
                v-if="!$store.state.courses.readMode"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>

          <div
            class="courses-single-title courses-title-frame courses-lesson-title"
          >
            <i class="fa-title"></i>
            <h2 v-if="lesson" v-cyr2lat="$store.getters.lang">
              {{ lesson.name }}
            </h2>
          </div>

          <div
            v-if="lesson"
            class="courses-single-lesen-info content-unset"
            :class="['size-' + fontSize]"
            v-html="processedLessonText"
          ></div>

          <a
            v-if="button_type === 'next'"
            href="#"
            class="start-lesson"
            @click.prevent="nextCourse"
          >
            <div v-cyr2lat="$store.getters.lang">{{ $t("next") }}</div>
            <i class="fa-arrow-line"></i
          ></a>
          <a
            v-if="button_type === 'quiz'"
            href="#"
            class="start-lesson"
            @click.prevent="nextTest($route.params.id)"
          >
            <div v-cyr2lat="$store.getters.lang">{{ $t("to_test") }}</div>
            <i class="fa-arrow-line"></i
          ></a>
          <a
            v-if="button_type === 'final'"
            style="width: 260px"
            href="#"
            class="start-lesson"
            @click.prevent="nextFinish($route.query.id)"
          >
            <div v-cyr2lat="$store.getters.lang">{{ $t("to_final_test") }}</div>
            <i class="fa-arrow-line"></i
          ></a>
          <a
            v-if="button_type === 'no'"
            href="#"
            class="start-lesson"
            @click.prevent="completeCourse(lesson.id, 'finished')"
          >
            <div v-cyr2lat="$store.getters.lang">{{ $t("ready") }}</div>
            <i class="fa-title"></i
          ></a>
        </template>
      </template>
    </template>
    <template v-else><v-loader /></template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      button_type: "next",
      loading: false,
      fontSize: 3,
    };
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("getCourse", this.$route.query.id);
    await this.$store.dispatch("getLessonById", this.$route.params.id);
    if (this.user) {
      if (this.lesson.process_status !== "finished")
        await this.completeCourse(this.$route.params.id, "progress");
    }
    this.checkedLast(this.$route.params.id);
    this.loading = false;
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    this.loading = true;
    this.checkedLast(to.params.id);
    await this.$store.dispatch("getLessonById", to.params.id);
    if (this.lesson.process_status !== "finished") {
      await this.completeCourse(to.params.id, "progress");
    }
    this.loading = false;
  },
  computed: {
    lesson() {
      return this.$store.getters.getLesson;
    },
    course() {
      return this.$store.getters.getCourse;
    },
    user() {
      return this.$store.getters.getUserCredentials;
    },
    processedLessonText() {
      if (!this.lesson || !this.lesson.text) return "";
      // Use global utility to process HTML content with image URLs
      return this.$processHtml(this.lesson.text);
    },
  },
  methods: {
    async completeCourse(id, status) {
      await this.$store.dispatch("completeCourse", { id: id, status: status });
      //this.lesson.status = status
    },
    async nextCourse() {
      this.loading = true;
      if (localStorage.getItem("access")) {
        let nextId = null;
        const material = this.course?.material;
        if (material) {
          for (let i = 0; i < material.length; i++) {
            const topic = material[i];
            const lessonIdx = topic.lessons.findIndex(
              (l) => l.id == this.$route.params.id
            );
            if (lessonIdx !== -1) {
              if (topic.lessons[lessonIdx + 1]) {
                nextId = topic.lessons[lessonIdx + 1].id;
              } else if (material[i + 1]?.lessons?.length) {
                nextId = material[i + 1].lessons[0].id;
              }
              break;
            }
          }
        }
        await this.completeCourse(this.$route.params.id, "finished");
        if (nextId) {
          await this.$router.push(
            `/lessons/${nextId}?id=${this.$route.query.id}`,
          );
        }
      } else {
        await this.$store.commit("setError", "no-auth");
        await this.$router.push("/login");
      }
      this.loading = false;
    },
    async nextTest(id) {
      this.loading = true;
      let nextSlug = null;
      const material = this.course?.material;
      if (material) {
        const topic = material.find((t) =>
          t.lessons.some((l) => l.id == id)
        );
        if (topic?.quiz?.slug) {
          nextSlug = topic.quiz.slug;
        }
      }
      await this.completeCourse(id, "finished");
      if (nextSlug) {
        await this.$router.push(`/quiz/${nextSlug}?id=${this.$route.query.id}`);
      }
      this.loading = false;
    },
    last(e) {
      return e[e.length - 1];
    },
    checkedLast(id) {
      this.button_type = "next";
      const material = this.course?.material;
      if (!material || !material.length) return;

      const topic = material.find(
        (t) => t.lessons.length && t.lessons[t.lessons.length - 1].id == id
      );
      if (topic) {
        if (topic.quiz) {
          this.button_type = "quiz";
        } else {
          this.button_type = "next";
        }
      }

      const lastTopic = material[material.length - 1];
      const lastLesson = lastTopic.lessons?.length
        ? lastTopic.lessons[lastTopic.lessons.length - 1]
        : null;
      if (lastLesson && lastLesson.id == id) {
        if (lastTopic.quiz) {
          this.button_type = "quiz";
        } else if (this.course.final_quiz) {
          this.button_type = "final";
        } else {
          this.button_type = "no";
        }
      }
    },
    nextFinish(id) {
      if (this.course?.final_quiz?.slug) {
        this.$router.push(`/final-quiz/${this.course.final_quiz.slug}?id=${id}`);
      }
    },
    lessSize() {
      this.fontSize = this.fontSize > 1 ? this.fontSize - 1 : 1;
    },
    moreSize() {
      this.fontSize = this.fontSize < 6 ? this.fontSize + 1 : 6;
    },
  },
};
</script>
